import React, { useEffect } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { Button, Typography, useTheme } from "@mui/material";

import UserContainer from "../../components/layout/container/UserContainer";
import SimpleBox from "../../components/layout/container/SimpleBox";
import TextInput from "../../components/input/text/TextInput";
import { apiPublicMbwayInfo, apiPublicMbwayRequest } from "../../api/public";
import { formatNumberAmount } from "../../helpers/format";

const MbwayPayment = () => {

    const theme = useTheme();
    const params = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [notFound, setNotFound] = React.useState(false);
    const [info, setInfo] = React.useState(null);
    const [phoneNumber, setPhoneNumber] = React.useState("");
    const [errorText, setErrorText] = React.useState(null);
    const [requestSent, setRequestSent] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    useEffect(() => {
        apiPublicMbwayInfo({ paymentReferenceId: params.paymentReferenceId }, (data, success) => {
            if (success > 0) {
                setInfo(data);
                setPhoneNumber(data.phoneNumber ?? "");
            }
            else {
                setNotFound(true);
            }
            setIsLoaded(true);
        });
    }, [params.paymentReferenceId]);

    const handleSubmit = () => {
        if (isSubmitting) return;
        if (!phoneNumber) {
            setErrorText("O número de telemóvel é obrigatório");
            return;
        }
        setErrorText(null);
        setIsSubmitting(true);
        apiPublicMbwayRequest({ paymentReferenceId: params.paymentReferenceId, phoneNumber }, (data, success) => {
            setIsSubmitting(false);
            if (success > 0) {
                setRequestSent(true);
                toast.success("Pedido de pagamento MBWAY enviado com sucesso!");
            }
        });
    }

    if (!isLoaded) {
        return <UserContainer title="Pagamento MBWAY" message="" checkUid={false} />;
    }

    if (notFound) {
        return (
            <UserContainer
                title="Pagamento MBWAY"
                message="Não foi possível encontrar esta referência de pagamento. Verifique se o link está correto ou contacte-nos."
                checkUid={false} />
        );
    }

    if (info.isPaid) {
        return (
            <UserContainer
                title="Pagamento MBWAY"
                message="Pagamento confirmado com sucesso! Amanhã o registo do pagamento será atualizado e a respetiva fatura será gerada automaticamente."
                checkUid={false} />
        );
    }

    if (requestSent || info.mbwayRequested) {
        return (
            <UserContainer
                title="Pagamento MBWAY"
                message="O pedido de pagamento foi enviado para o seu telemóvel. Siga as instruções na aplicação do seu banco para aceitar o pagamento. Em caso de sucesso, a fatura correspondente ser-lhe-á enviada amanhã."
                checkUid={false} />
        );
    }

    return (
        <UserContainer
            title="Pagamento MBWAY"
            message={`Indique o número de telemóvel para onde pretende receber o pedido de pagamento MBWAY no valor de ${formatNumberAmount(info.amount)}.`}
            checkUid={false}
        >
            <SimpleBox gap={4} flexDirection="column" mt={6} alignItems="left">
                <TextInput
                    id="phoneNumber"
                    label="Número de Telemóvel"
                    value={phoneNumber}
                    errorText={errorText}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value);
                        setErrorText(null);
                    }} />
                <Button variant="contained" color="primary" fullWidth={true} disabled={isSubmitting} onClick={handleSubmit}>Pagar com MBWAY</Button>
            </SimpleBox>
        </UserContainer>
    );
};

export default MbwayPayment;
